import React, { createContext, useEffect } from 'react';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { useLocation } from 'react-router-dom';
import useFetchState from '../hooks/useFetchState';
import { getSorisOrderNumberBarcode } from '../api/returns/soris-api';
import { getEjKey } from '../utils/order-details/OrderDetailsUtils';
import { isCashNCarryOrder } from '../components/shared/order-number-formatter/OrderNumberFormatter';
import { getTransactionType } from '../utils/returns/returns-helper';
import { FeatureSwitches } from '../constants/feature-switches';
var defaultState = {
    orderBarcodeApiState: undefined,
};
// Create the context with a default value
export var Phase0BarcodeContext = createContext(defaultState);
export var Phase0BarcodeProvider = function (_a) {
    var orderDetailsData = _a.orderDetailsData, orderDetailsLoaded = _a.orderDetailsLoaded, children = _a.children;
    var isB2CCustomer = useThdCustomer().isB2CCustomer;
    var location = useLocation();
    var urlParams = new URLSearchParams(location.search);
    var isReturnReceiptOrder = (orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.statusDescription) === 'Returned';
    var isGuestOrder = location.pathname === '/myaccount/guest-order-tracking';
    var orderNumber = urlParams.get('orderNumber')
        ? String(urlParams.get('orderNumber'))
        : orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber;
    var transactionId = urlParams.get('transactionId')
        ? Number(urlParams.get('transactionId'))
        : orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.transactionId;
    var registerNumber = urlParams.get('registerNumber')
        ? Number(urlParams.get('registerNumber'))
        : orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.registerNumber;
    var transactionType = getTransactionType(urlParams.get('transactionType'), orderDetailsData);
    // Initializing the order barcode API state hook
    var orderBarcodeApiState = useFetchState();
    var data = orderBarcodeApiState.data, isFetched = orderBarcodeApiState.isFetched;
    var isCashNCarryOrderNumber = isCashNCarryOrder(orderNumber || '', orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderOrigin, registerNumber, transactionId);
    useEffect(function () {
        // If order number is online or H Order, call order # barcode API with order number
        if (!isCashNCarryOrderNumber && orderNumber && !isFetched) {
            // Guest Orders have no URL Params, so it must be fetched from order details
            if (!data && isGuestOrder && orderDetailsLoaded) {
                var getOrderNumberBarcodeRequest_1 = {
                    orderType: 'ONLINE',
                    orderNumber: orderNumber,
                };
                orderBarcodeApiState.fetchData(function () {
                    return getSorisOrderNumberBarcode(getOrderNumberBarcodeRequest_1);
                });
            }
            // online orders when logged in are able to fetch with only URL params
            else if (!data && !isGuestOrder) {
                var getOrderNumberBarcodeRequest_2 = {
                    orderType: 'ONLINE',
                    orderNumber: orderNumber,
                };
                orderBarcodeApiState.fetchData(function () {
                    return getSorisOrderNumberBarcode(getOrderNumberBarcodeRequest_2);
                });
            }
        }
    }, [orderDetailsLoaded]);
    useEffect(function () {
        var returnReceiptAllowed = FeatureSwitches.enableP0ReturnReceiptBarcode || !isReturnReceiptOrder;
        if (orderDetailsLoaded &&
            !isFetched &&
            isCashNCarryOrderNumber &&
            returnReceiptAllowed) {
            var _a = getEjKey(orderDetailsData, isB2CCustomer), ejRegister = _a.ejRegister, ejSeqNo = _a.ejSeqNo, ejStore = _a.ejStore, ejDate = _a.ejDate;
            // Dont call barcode for in-store orders that do not yet have EJ keys available
            var areEJKeysPresent = ejRegister && ejSeqNo && ejStore && ejDate;
            if (!areEJKeysPresent)
                return;
            var getInStoreOrderNumberBarcodeRequest_1 = {
                orderType: 'RECEIPT',
                ejKey: {
                    ejDate: ejDate,
                    ejRegister: ejRegister,
                    ejSeqNo: ejSeqNo,
                    ejStore: ejStore,
                    transactionType: transactionType,
                },
            };
            orderBarcodeApiState.fetchData(function () {
                return getSorisOrderNumberBarcode(getInStoreOrderNumberBarcodeRequest_1);
            });
        }
    }, [orderDetailsLoaded]);
    return (React.createElement(Phase0BarcodeContext.Provider, { value: {
            orderBarcodeApiState: orderBarcodeApiState,
        } }, children));
};
